import React from 'react';
import { useNavigate } from 'react-router-dom';
import PopupServiceImg from 'Assets/layout/dashboard/popup-service.png';
import QuickButton from 'Douleutaras/components/QuickButton/QuickButton';
import DefaultModal from 'Douleutaras/components/modals/DefaultModal';
import { Trans, useTranslation } from 'react-i18next';
import Modal from 'Douleutaras/components/Modal/Modal';
import ModalSelectionItem from 'Douleutaras/components/modals/parts/ModalSelectionItem';
import { CCFModalOptions } from 'Douleutaras/types/index';
import { WhatHappenedModalTranslated } from 'Douleutaras/constants/ccf/need-help-options';
import { requestCcfExtraBid } from 'Douleutaras/functional-components/ccf/lib/actions';
import { ExtraBidSource, useAB } from 'Douleutaras/app/lib/ab';
import { useJobExtraBidState } from 'Douleutaras/hooks/jobs/jobExtraBidState';

interface WhatHappenedModalProps {
  isOpen: boolean;
  options: CCFModalOptions;
  jobId: string;
  jobCategoryId: string;
  title: React.ReactElement;
  userMugshot: string;
  onBack(): void;
  setIsOpen(modalStatus): void;
  onOptionSelected?(userSelection): void;
  onCCFModalOptionSelected?({ optionSlug }: { optionSlug: string }): void;
}

export const WhatHappenedModal =
  ({ isOpen, setIsOpen, options = {}, onBack, onOptionSelected, jobId, jobCategoryId, onCCFModalOptionSelected, title, userMugshot }
                                    : WhatHappenedModalProps) => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const { captureExtraBid } = useAB();
  const { bidsCount } = useJobExtraBidState(jobId);

  return (
    <Modal isOpen={isOpen} dismissCallback={() => setIsOpen(false)}>
      <DefaultModal
        serviceIcon={PopupServiceImg}
        serviceIconAlt={<Trans t={t}>T.CCF.WHAT HAPPENED.ICON ALT TEXT</Trans>}
        title={title}
        backText={<Trans t={t}>T.CCF.WHAT HAPPENED.BACK BUTTON TEXT</Trans>}
        backTextAriaLabel={<Trans t={t}>T.CCF.WHAT HAPPENED.BACK BUTTON TEXT</Trans>}
        closeAriaLabel={<Trans t={t}>T.CCF.WHAT HAPPENED.CLOSE ICON LABEL</Trans>}
        closeButtonCallback={() => setIsOpen(false)}
        backButtonCallback={typeof onBack === 'function' ? onBack : () => false}
        userMugshot={userMugshot}
        showBackButton
      >
        <div>
          { Object.keys(options)
            .filter(optionKey => options[optionKey]?.active)
            .map(optionKey => {

              // When a special option is selected, request an extra pro
              const onClickAction = optionKey === 'suggested_pro_does_not_cover_me_i_need_an_extra_pro'
                ? () => {
                  // @AB PostHog event
                  requestCcfExtraBid({
                    jobId,
                    bidsCount,
                    navigate,
                    onOptionSelected: onCCFModalOptionSelected,
                    eventTracking: captureExtraBid,
                    eventValue: ExtraBidSource.CCF_NEED_HELP
                  });
                }
                : () => onOptionSelected({
                  optionSlug: optionKey,
                  modalSlug: options[optionKey]?.modal,
                  modalOptions: options[optionKey]?.modal_options
                });

              return (
                <ModalSelectionItem key={`wh_option_${optionKey}`}>
                  <QuickButton
                    title={WhatHappenedModalTranslated[optionKey]}
                    onClick={onClickAction}
                  />
                </ModalSelectionItem>
              );
          })}
        </div>
      </DefaultModal>
    </Modal>
  );
};

export default WhatHappenedModal;
